import {NgModule} from "@angular/core";
import {FamilleEgalimComponent} from "./famille-egalim/famille-egalim.component";
import {EgalimRoutingModule} from "./egalim-routing.module";
import {StatistiquesEgalimComponent} from "./statistiques-egalim/statistiques-egalim.component";
import {EgalimRootComponent} from "./egalim-root.component";
import {SharedModule} from "../shared/shared.module";
import {
  DxBarGaugeModule,
  DxCheckBoxModule,
  DxDataGridModule, DxLoadIndicatorModule, DxLoadPanelModule,
  DxLookupModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxTextBoxModule,
  DxToolbarModule
} from "devextreme-angular";
import {FamilleEgalimDialogComponent} from "./famille-egalim/famille-egalim-dialog/famille-egalim-dialog.component";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {PointTeledeclarationEgalimComponent} from "./points-teledeclaration-egalim/point-teledeclaration-egalim.component";
import {PointTeledeclarationEgalimEditionComponent} from "./points-teledeclaration-egalim/edition-dialog/point-teledeclaration-egalim-edition.component";
import {CommonModule} from "@angular/common";
import {StatistiquesEgalimCreationDialogComponent} from "./statistiques-egalim/statistiques-egalim-creation-dialog/statistiques-egalim-creation-dialog.component";
import {MaCantineConnectionDialogComponent} from "./statistiques-egalim/ma-cantine-connection-dialog/ma-cantine-connection-dialog.component";
import {StatistiquesEgalimDetailsDialogComponent} from "./statistiques-egalim/statistiques-egalim-details-dialog/statistiques-egalim-details-dialog.component";
import {StatistiquesEgalimErrorDialogComponent} from "./statistiques-egalim/statistiques-egalim-error-dialog/statistiques-egalim-error-dialog.component";
import {DxoFontModule, DxoLegendModule, DxoSubtitleModule, DxoTitleModule, DxoTooltipModule} from "devextreme-angular/ui/nested";
import {StatistiquesEgalimConformiteDialogComponent} from "./statistiques-egalim/statistiques-egalim-conformite-dialog/statistiques-egalim-conformite-dialog.component";
import {IndicateurEgalimComponent} from "./indicateur-egalim/indicateur-egalim.component";

@NgModule({
  imports: [
    EgalimRoutingModule,
    SharedModule,
    DxDataGridModule,
    DxPopupModule,
    ReactiveFormsModule,
    DxLookupModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxCheckBoxModule,
    DxToolbarModule,
    CommonModule,
    DxBarGaugeModule,
    DxoFontModule,
    DxoLegendModule,
    DxoSubtitleModule,
    DxoTitleModule,
    DxoTooltipModule,
    FormsModule,
    DxLoadPanelModule,
    DxLoadIndicatorModule
  ],
  exports: [
    IndicateurEgalimComponent
  ],
  declarations: [
    EgalimRootComponent,
    FamilleEgalimComponent,
    FamilleEgalimDialogComponent,
    StatistiquesEgalimComponent,
    StatistiquesEgalimCreationDialogComponent,
    PointTeledeclarationEgalimComponent,
    PointTeledeclarationEgalimEditionComponent,
    MaCantineConnectionDialogComponent,
    StatistiquesEgalimDetailsDialogComponent,
    StatistiquesEgalimErrorDialogComponent,
    StatistiquesEgalimConformiteDialogComponent,
    IndicateurEgalimComponent
  ]
})
export class EgalimModule {
}
